import { render, staticRenderFns } from "./VFilters.vue?vue&type=template&id=1fc23864&"
import script from "./VFilters.vue?vue&type=script&lang=js&"
export * from "./VFilters.vue?vue&type=script&lang=js&"
import style0 from "./VFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports